import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './About.css';

const About: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // 处理锚点跳转
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="about-page">
      <div className="page-header">
        <h1>About Us</h1>
        <p>Upwork Sdn. Bhd. - Your Trusted Partner for Hotel Amenities</p>
      </div>

      <div className="container">
        {/* Statistics Section */}
        <div className="stats-section">
          <div className="stat-item">
            <div className="stat-number">3+</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">50+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
        </div>

        {/* Company Overview Section */}
        <div id="company-overview" className="about-section">
          <h2>Company Overview</h2>
          <p>
            Upwork Sdn. Bhd. is a leading supplier of quality amenities for hotels and 
            wellness businesses in Malaysia. We focus on quality and customer satisfaction, 
            and have become a go-to partner for hotels and other hospitality venues nationwide.
          </p>
          <p>
            We provide full hotel amenity solutions that match the needs of today’s 
            hospitality operators. We know that good amenities are key to guest satisfaction 
            and a strong brand.
          </p>
          
          <div className="values-section">
            <h3>Our Values</h3>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">Q</div>
                <h4>Quality</h4>
                <p>We maintain high standards and ensure every product meets international benchmarks.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">P</div>
                <h4>Partnership</h4>
                <p>We build long-term relationships with clients through trust and shared success.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">S</div>
                <h4>Sustainability</h4>
                <p>We offer eco-friendly options for properties that care about the environment.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">❤</div>
                <h4>Service</h4>
                <p>We focus on prompt, professional service so your needs are always met.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Operation Section */}
        <div id="our-operation" className="about-section">
          <h2>Our Operation</h2>
          <p>
            We run our business with a focus on efficiency, reliability, and customer 
            satisfaction. From order to delivery, we aim to provide smooth service at every step.
          </p>
          
          <div className="operation-details">
            <div className="operation-item">
              <h3>Supply Chain Excellence</h3>
              <p>
                We work with a strong supply chain so products are consistently in stock. 
                Our partnerships with manufacturers and suppliers allow competitive prices 
                without cutting corners on quality.
              </p>
            </div>
            <div className="operation-item">
              <h3>Quality Assurance</h3>
              <p>
                Every product is checked for quality before it enters our catalog. We work with 
                suppliers to ensure items meet international standards and our own strict requirements.
              </p>
            </div>
            <div className="operation-item">
              <h3>Customer Support</h3>
              <p>
                Our customer service team is ready to help with questions, orders, and follow-up. 
                We aim to respond quickly and to tailor our support to each client.
              </p>
            </div>
            <div className="operation-item">
              <h3>Delivery & Logistics</h3>
              <p>
                We know that on-time delivery matters in hospitality. Our logistics are set up 
                to process and deliver orders quickly so you can run your operations without delay.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div id="faq" className="about-section">
          <h2>Frequently Asked Questions (FAQ)</h2>
          <div className="faq-list">
            <div className="faq-item">
              <h3>What types of hotel amenities do you supply?</h3>
              <p>
                We supply a wide range of hotel amenities: bathroom items, bedroom accessories, 
                dining and tableware, wellness products, and more. Our catalog covers the essentials 
                for day-to-day hotel operations.
              </p>
            </div>
            <div className="faq-item">
              <h3>Do you offer custom branding options?</h3>
              <p>
                Yes. We work with hotels on custom branding so you can have amenity sets that 
                match your brand and improve the guest experience.
              </p>
            </div>
            <div className="faq-item">
              <h3>What is your minimum order quantity?</h3>
              <p>
                Minimum order sizes depend on the product. We serve hotels of all sizes and can 
                work with both small and large orders. Contact us for details.
              </p>
            </div>
            <div className="faq-item">
              <h3>How do you ensure product quality?</h3>
              <p>
                We have a clear quality assurance process. Products are sourced from trusted 
                manufacturers and checked before they are listed. We also run regular audits 
                to keep standards high.
              </p>
            </div>
            <div className="faq-item">
              <h3>What are your delivery times?</h3>
              <p>
                Delivery depends on stock and order size. Most orders are processed within 
                3–5 business days. We can arrange faster delivery for urgent needs—contact us 
                for exact timelines.
              </p>
            </div>
            <div className="faq-item">
              <h3>Do you serve hotels outside of Malaysia?</h3>
              <p>
                Right now we mainly serve hotels in Malaysia. We are growing and may be able to 
                support international orders—get in touch to discuss your needs.
              </p>
            </div>
          </div>
        </div>

        {/* Vision & Mission Section */}
        <div className="vision-mission-section">
          <div className="vision-mission-grid">
            <div className="vision-mission-item">
              <h2>Our Vision</h2>
              <p>
                To be the most trusted and respected hotel amenity supplier in Malaysia—known for 
                quality, reliability, and excellent customer service.
              </p>
            </div>
            <div className="vision-mission-item">
              <h2>Our Mission</h2>
              <p>
                To improve guest experiences across Malaysia’s hospitality sector by supplying 
                high-quality amenities with strong service, reliability, and value.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
